import styled from 'styled-components';
import { Button, Row } from '@simplywallst/ui-core';

export const MultipleVsPeersChartWrapper = styled('div')`
  display: flex;
  width: 100%;
  height: 362px;
  user-select: none;
`;

export const ChartArea = styled('div')`
  width: 100%;
  height: 100%;
  overflow: visible;
`;

export const EarningsGrowthColumn = styled('svg')`
  width: max(min(59px, 12vw), 59px);
  overflow: visible;
  margin-left: ${({ theme }) => theme.x1spacePx}px;
  height: 100%;
  flex-shrink: 0;
`;

export const TooltipName = styled('span')`
  border-bottom: 1px dotted ${({ theme }) => theme.color.brand01};
  cursor: help;
  width: fit-content;
  ${({ theme }) => theme.typography.tiny}
  line-height: 16px;
  opacity: 0.7;
`;

export const TipContainer = styled('p')`
  margin: 0;
  max-width: 200px;
  ${({ theme }) => theme.typography.tiny};
`;

export const EarningsGrowthBackground = styled('rect')`
  fill: ${({ theme }) => theme.color.spaceGray};
`;

export const LabelButton = styled(Button)`
  padding: 0;
`;

export const LoadingState = styled(Row)`
  position: absolute;
  top: 36px;
  left: 0;
  width: 100%;
  height: calc(100% - 87px);
  background: ${({ theme }) => theme.color.charcoalRGBA(0.8)};
  z-index: 1;
`;
